import { AppConfig } from '@/types/AppConfig.type';

export const DEFAULT_FACTORY_DISTANCE_THRESHOLD_M = 500;
export const DEFAULT_MIN_GPS_ACCURACY_METERS = 100;

export function isFactoryVerificationEnabled(
  config: Pick<AppConfig, 'factory-verification'>
): boolean {
  return config['factory-verification']?.enable === true;
}

export function getFactoryDistanceThresholdMeters(
  config: Pick<AppConfig, 'factory-verification'>
): number {
  const value = config['factory-verification']?.['distance-threshold-meters'];
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value;
  }
  return DEFAULT_FACTORY_DISTANCE_THRESHOLD_M;
}

export function getMinGpsAccuracyMeters(config: Pick<AppConfig, 'factory-verification'>): number {
  const value = config['factory-verification']?.['min-gps-accuracy-meters'];
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value;
  }
  return DEFAULT_MIN_GPS_ACCURACY_METERS;
}
